import AppBar from "@mui/material/AppBar";
import Grid from "@mui/material/Grid";
import { withStyles, WithStyles } from "@mui/styles";
import Toolbar from "@mui/material/Toolbar";
import headerLinksStyle from "assets/jss/layouts/headerLinksStyle";
import headerStyle from "assets/jss/layouts/headerStyle";
import classNames from "classnames";
import AppLogo from "components/AppLogo";
import AppTitle from "components/AppTitle";
import * as React from "react";
import { RouteComponentProps, Link } from "react-router-dom";
import { RoutePaths } from "routes/RouteConfig";
import HeaderCreationMenu from "./HeaderCreationMenu";
import HeaderNotification from "./HeaderNotification";
import HeaderSearch from "./HeaderSearch";
import HeaderUserMenu from "./HeaderUserMenu";
import { GlobalSearchStyleClasses } from "assets/jss/common-styles";
import { WithTranslation, withTranslation } from "react-i18next";
import { AccessKeys } from "Constants";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    fullView: boolean;
};

type Props = IProps & RouteComponentProps & WithStyles<typeof headerStyle> & WithStyles<typeof headerLinksStyle> & WithStyles<typeof GlobalSearchStyleClasses> & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////

class Header extends React.Component<Props> {

    public render() {
        const { classes, fullView, ...rest } = this.props;
        const appBarClasses = classNames(classes.appBar, classes.headerColor);

        return (
            <AppBar position="fixed" className={appBarClasses}>
                <Toolbar className={classes.toolbar}>
                    <div className={classes.logo}>
                        <Link to={RoutePaths.TimelineStartup} title={this.props.t("Common.TopHeader.GoHomeTitle")} accessKey={AccessKeys.FeedStartup}>
                            <AppLogo />
                        </Link>
                    </div>

                    <Grid container direction="column" alignItems="stretch" >
                        <Grid item xs={12} className={classes.logoText}  >
                            <AppTitle />
                        </Grid>
                        {
                            fullView &&
                            <Grid item xs={12}>
                                <div style={{ display: "flex" }}>
                                    <HeaderSearch classes={classes} />
                                    <HeaderCreationMenu classes={classes} />
                                    <HeaderNotification classes={classes} />
                                    <HeaderUserMenu classes={classes}  {...rest} />
                                </div>
                            </Grid>
                        }
                    </Grid>

                </Toolbar>
            </AppBar>

        );
    }
}


const withAllStyles = withStyles(
    (theme) => ({
        ...headerStyle(theme),
        ...headerLinksStyle(theme),
        ...GlobalSearchStyleClasses(theme)
    }),
    { withTheme: true },
);

export default withTranslation()(withAllStyles(Header));
